import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import React from "react";
import { useSelector } from "react-redux";

function Loader(){
    const loader: any = useSelector((Selectorstate: any) => Selectorstate.loader);
    return (<>
        <SimpleLoader {...loader.loaderState}/>
    </>)
}

export default Loader

export function SimpleLoader({ show }: any) {
    return (
       <div>

      <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={show}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
        </div>
    );
}
